"use client";

import { useQuery } from "@tanstack/react-query";
import { GetEfficiencyStatsQuery } from "@/graphql/gql/graphql";
import { getTeamEfficiencyOverview } from "@/utils/api";
import TeamStatsHeader from "./TeamStatsHeader";
import { TeamStatsRow } from "./TeamStatsRow";
import styles from "./teamStats.module.scss";

interface TeamStatsClientProps {
  data: GetEfficiencyStatsQuery;
  eventId: number;
}

export default function TeamStatsClient({
  data,
  eventId,
}: TeamStatsClientProps) {
  useQuery({
    queryFn: () => getTeamEfficiencyOverview(eventId),
    queryKey: ["teamEfficiencyStats", eventId],
    initialData: data,
    enabled: false,
  });
  const results = data.event;

  return (
    <div className={styles.container}>
      <div className={styles.teamStatsCard}>
        <TeamStatsHeader
          homeTeam={results?.homeTeam}
          awayTeam={results?.awayTeam}
        />
        <TeamStatsRow
          homeTeam={results?.homeTeam}
          awayTeam={results?.awayTeam}
          dataKey={"adjOffNEP"}
          label="Offensive EPA"
        />
        <TeamStatsRow
          homeTeam={results?.homeTeam}
          awayTeam={results?.awayTeam}
          dataKey={"adjOffPassNEP"}
          label="Passing EPA"
        />
        <TeamStatsRow
          homeTeam={results?.homeTeam}
          awayTeam={results?.awayTeam}
          dataKey={"adjOffRushNEP"}
          label="Rushing EPA"
        />
        <TeamStatsRow
          homeTeam={results?.homeTeam}
          awayTeam={results?.awayTeam}
          dataKey={"adjDefNEP"}
          label="Defensive EPA"
        />
        <TeamStatsRow
          homeTeam={results?.homeTeam}
          awayTeam={results?.awayTeam}
          dataKey={"adjDefPassNEP"}
          label="Def Pass EPA"
        />
        <TeamStatsRow
          homeTeam={results?.homeTeam}
          awayTeam={results?.awayTeam}
          dataKey={"adjDefRushNEP"}
          label="Def Rush EPA"
        />
      </div>
    </div>
  );
}
